import { render, staticRenderFns } from "./AnalyticsCurrencyFilter.vue?vue&type=template&id=0b876189&scoped=true"
import script from "./AnalyticsCurrencyFilter.vue?vue&type=script&lang=js"
export * from "./AnalyticsCurrencyFilter.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsCurrencyFilter.vue?vue&type=style&index=0&id=0b876189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b876189",
  null
  
)

export default component.exports